import React from "react";

import { Flex, Icon, Spin, Tag, TagColour, Tooltip, Typography, TypographyVariant } from "components";

export interface CardContentGroupProps {
  title: string | number;
  titleVariant?: "paragraph-m" | "paragraph-l" | "paragraph-m-bold" | "paragraph-l-bold";
  description?: string | React.ReactNode;
  largeDescription?: boolean;
  grow?: boolean;
  align?: "left" | "center" | "right";
  tooltipTitle?: string;
  tag?: null | { text: string; colour: TagColour; tooltip?: string }[];
  tagPosition?: "top" | "inline";
  loading?: boolean;
}

export const CardContentGroup = ({
  title,
  titleVariant = "paragraph-l",
  description,
  largeDescription = false,
  tag,
  tooltipTitle,
  align = "left",
  grow = false,
  loading = false,
  tagPosition = "top",
}: CardContentGroupProps) => (
  <Flex className={`${grow ? "flex-1" : ""} footprint-button-card-column ${align}`} vertical justify="center">
    {tagPosition === "top" && tag && tag.length > 0 ? (
      <Flex className="tag-wrapper" justify="center" gap={4}>
        {tag.map((tagItem, index) => (
          <Tooltip key={index} disabled={!tagItem.tooltip} placement="top" title={tagItem.tooltip}>
            <Tag className="footprint-button-tag top" text={tagItem.text} colour={tagItem.colour} />
          </Tooltip>
        ))}
      </Flex>
    ) : null}
    {tagPosition === "inline" ? (
      <Flex className="margin-0 padding-0" align="center" gap={8} wrap>
        <Typography variant={titleVariant as TypographyVariant}>{title}</Typography>
        {tag &&
          tag.length > 0 &&
          tag.map((tagItem, index) => (
            <Tooltip key={index} disabled={!tagItem.tooltip} placement="top" title={tagItem.tooltip}>
              <Tag className="footprint-button-tag" text={tagItem.text} colour={tagItem.colour} />
            </Tooltip>
          ))}
      </Flex>
    ) : (
      <Typography variant={titleVariant as TypographyVariant}>{loading ? <Spin /> : title}</Typography>
    )}
    <Tooltip disabled={tooltipTitle === undefined} placement="bottom" title={tooltipTitle}>
      <Typography
        variant={largeDescription ? "paragraph-m" : "paragraph-s"}
        color="grey-600"
        className={`margin-0 padding-0 ${largeDescription ? "margin-top-25" : ""}`}
      >
        {description} {tooltipTitle ? <Icon size="s" iconName="tabler/info-circle" className="icon inline" /> : null}
      </Typography>
    </Tooltip>
  </Flex>
);
